import { Component, ViewEncapsulation } from '@angular/core';
import { DateTime as LuxonDateTime } from 'luxon';

@Component({
    selector: 'tidy-best-times-calendar',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./best-times-calendar.component.scss'],
    templateUrl: 'best-times-calendar.component.html',
    standalone: false
})

export  class BestTimesCalendarComponent {

  weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

}
